module.exports = __webpack_public_path__ + "static/emulation-emulation-5e27f2f42f485ccd04f560ff9bb43a14.png";